import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ToastrService} from "ngx-toastr";
import {AppLoaderService} from "app/shared/services/app-loader/app-loader.service";
import {PropertyBillsApi, UserProfileApi} from "app/shared/services/sdk/services/custom";

@Component({
  selector: 'app-cancel-property-bill',
  templateUrl: './cancel-property-bill.component.html',
  styleUrls: ['./cancel-property-bill.component.scss']
})
export class CancelPropertyBillComponent implements OnInit {

  public invoice_data: any;
    public cancelInvoiceForm: FormGroup;

  constructor(public dialogRef: MatDialogRef<CancelPropertyBillComponent>,
              private toastr: ToastrService,
              private fb: FormBuilder,
              private appLoader: AppLoaderService,
              private userProfileApi: UserProfileApi,
              private propertyBillsApi: PropertyBillsApi,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
      const property_bill_data = this.data;

      this.cancelInvoiceForm = this.fb.group({
          id: [property_bill_data.id,  Validators.required],
          user_id: [this.userProfileApi.getCurrentId(),  Validators.required],
          memo: [null,  Validators.required]
      });
  }


    onNoClick(): void {
        this.dialogRef.close();
    }


    onSubmit() {
        this.appLoader.open('Cancelling property bill...');

        this.propertyBillsApi.cancelPropertyBill(this.cancelInvoiceForm.value).subscribe(
            response => {
                this.appLoader.close();
                this.toastr.success('Property bill successfully cancelled');
                this.dialogRef.close(response.success);
            },
            error => {
                this.appLoader.close();
                this.toastr.error(error.message);
            }
        );
    }

}
